import {z} from '@hono/zod-openapi';

import {amount} from './amount';

export const ArticleIssueChannelSchema = z
  .object({
    channel: z.enum(['COM', 'INS', 'CON', 'WAR', 'INT', 'CLA', 'DIRECT', 'OTHER']),
    netQuantity: amount.nullable(),
    sharePercent: amount.nullable(),
  })
  .openapi('ArticleIssueChannel');

export type ArticleIssueChannel = z.infer<typeof ArticleIssueChannelSchema>;
